import React, { useState } from 'react';
import { Button, Menu, MenuItem, Checkbox, ListItemText } from '@mui/material';

const AddUserMenu = ({ users, selectedUsers, onAdd, disabled = false, renderTrigger }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [pendingUsers, setPendingUsers] = useState([]);

    const handleOpen = (event) => {
        if (disabled) return;
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setPendingUsers([]);
    };

    const handleToggle = (userId) => {
        if (pendingUsers.includes(userId)) {
            setPendingUsers(pendingUsers.filter(id => id !== userId));
        } else {
            setPendingUsers([...pendingUsers, userId]);
        }
    };

    const handleAdd = () => {
        onAdd(pendingUsers);
        handleClose();
    };

    return (
        <div className="add-row-wrapper">
            {renderTrigger ? (
                renderTrigger(handleOpen, disabled)
            ) : (
                <Button
                    className="add-row-select"
                    onClick={handleOpen}
                    variant="outlined"
                    disabled={disabled}
                >
                    Add Row
                </Button>
            )}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            maxHeight: '40vh',
                            width: 250
                        }
                    }
                }}
            >
                {users.map(u => (
                    <MenuItem
                        key={u.value}
                        onClick={() => handleToggle(u.value)}
                        disabled={selectedUsers.some(su => su.value === u.value)}
                        data-cy={`add-user-option-${u.value}`}
                    >
                        <Checkbox checked={pendingUsers.includes(u.value)} />
                        <ListItemText primary={u.key} />
                    </MenuItem>
                ))}
                <div style={{ padding: '8px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', position: 'sticky', bottom: 0, background: 'white', zIndex: 1 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleAdd}
                        disabled={pendingUsers.length === 0}
                        data-cy="add-user-confirm-btn"
                    >
                        Add
                    </Button>
                </div>
            </Menu>
        </div>
    );
};

export default AddUserMenu;
